import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InvoiceStatus } from '@shared/services/gql.service';

import { InvoicesGridFormatterService } from './invoices-grid-formatter.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  selector: 'aux-ag-invoices-status',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center whitespace-nowrap">
      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="bgClass"></div>
      <div [ngClass]="textClass">{{ status }}</div>
    </div>
  `,
})
export class InvoicesStatusComponent implements ICellRendererAngularComp {
  bgClass!: string;
  params!: ICellRendererParams;
  status!: string;
  textClass!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: InvoiceStatus | string = params.data?.invoice_status || params.value || '';

    const { bgClass, label, textClass } =
      InvoicesGridFormatterService.getInvoiceStatusStyles(status);

    this.bgClass = bgClass;
    this.textClass = textClass;
    this.status = label;
  }

  refresh(): boolean {
    return false;
  }
}
